const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);
let mobile = window.innerWidth;
let siteUrl = window.location.origin;


/*--------------------------------------------------------------------------------
# START JS CUSTOM HOME PAGE ||||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

const allImgs = $$('img')

if(allImgs){
    allImgs.forEach((img)=>{
        img.classList.add('no-select')
    })
}

if(document.body.classList.contains('index-custom')){

    const sectionInstagram = $('section#shopify-section-sections--18887207747651__17736896558fcd8dd8')
    if(sectionInstagram){
        sectionInstagram.classList.add('not')
    }

    const section = $$('section')

    if(section){
        section.forEach(s => {
            if(!s.classList.contains('not')){
                s.style.margin = "0";
            }
        });
    }

    const bannerContent = $$('.slideshow__slide .banner__content'); 

        if (bannerContent) {
            bannerContent.forEach((item, i) => {
                if (mobile > 1200 && i == 0) {item.style.padding = '0';}
                if (mobile > 1200 && i == 3) {item.style.padding = '60px 0 0 0';}
                if (mobile > 1200 && i == 4) {item.style.padding = '60px 0 0 0';}
                item.querySelector('.banner__box').style.maxWidth = "600px";
                item.querySelector('.banner__buttons').style.maxWidth = "100%";
                item.classList.add(`banner__content-${i}`);

                item.querySelector('h2').classList.add('carter-sans')
                if(item.querySelector('.banner__text.rte p')){
                        item.querySelector('.banner__text.rte p')
                }

            });
        }

        const slideshow = $('.slideshow.banner')

       if(slideshow){
            if(mobile>992 && mobile<1800){slideshow.classList.replace('banner--large','banner--medium')}                        
       }

            const btnPrev = $$('button.slider-button.slider-button--prev')[0];
            const btnNext = $$('button.slider-button.slider-button--next')[0];

            document.addEventListener('keydown', (e) => {

                if (e.key === 'ArrowRight' && btnNext) {
                    btnNext.click();
                } 
                
                else if (e.key === 'ArrowLeft' && btnPrev) {
                    btnPrev.click();
                }

            });
    /*--------------------------------------------------------------------------------
    # TESTIMONIAL HOME PAGE ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
    --------------------------------------------------------------------------------*/

    document.addEventListener("DOMContentLoaded", ()=>{

            const track = document.querySelector(".slider-track");

            let index = 0;

            /* render slides */

            testimonials.forEach(t => {
            const slide = document.createElement("div");
            slide.classList.add("slide");

            slide.innerHTML = `
            <div class="rating">
                <span>${t.rating}</span>
                <span class="stars">★★★★★</span>
            </div>
            <span class="vertical-divisor d-none d-lg-block"></span>
            <div class="client">
            ${t.name}, “${t.text}”
            </div>
            `;

            track.appendChild(slide);
            });

            const slides = document.querySelectorAll(".slide");

            /* update */

            // function update(){
            // track.style.transform =
            // `translateX(-${index * 100}%)`;
            // }

            // function update(){
            //     track.style.transform = `translateX(-${index * 100}%)`;
            // }

            function update(){
                slides.forEach((slide,i)=>{
                slide.style.display = (i === index) ? "flex" : "none";
                slide.style.opacity = (i === index) ? "1" : "0";
                });
            }

            update();

            slides.forEach((slide,i)=>{

            slide.classList.toggle("active", i === index);

            });

            /* controls */

            function next(){
            index++;
            if(index >= slides.length)
            index = 0;

            update();

            }

            function prev(){
            index--;
            if(index < 0)
            index = slides.length - 1;

            update();

            }

            document.querySelector(".next").onclick = next;
            document.querySelector(".prev").onclick = prev;

            /* autoplay */

            setInterval(next, 5000);

            /* swipe mobile */

            let startX = 0;

            track.addEventListener("touchstart", e=>{
            startX = e.touches[0].clientX;
            });

            track.addEventListener("touchend", e=>{

            let endX = e.changedTouches[0].clientX;
            if(startX - endX > 50) next();
            if(endX - startX > 50) prev();

            });

            });

    const testimonials = [

    {
    name: "Juliana Ferraz",
    rating: "5.0",
    text: "Todos perguntam o que estou usando"
    },

    {
    name: "Marina Lopes",
    rating: "5.0",
    text: "Recebo elogios sempre que uso"
    },

    {
    name: "Carla Mendes",
    rating: "5.0",
    text: "O perfume dura o dia inteiro"
    }

    ];


    /*--------------------------------------------------------------------------------
    # TRANSITION EFFECT HOME PAGE ||||||||||||||||||||||||||||||||||||||||||||||||||||
    --------------------------------------------------------------------------------*/

    document.addEventListener('DOMContentLoaded', () => {
        backgroundLoopFade('.transition-effect');
        backgroundLoopFadeText(
            '#shopify-section-template--18887207288899__image_banner_7XDTaA .banner__media',
            '#shopify-section-template--18887207288899__image_banner_7XDTaA h2.banner__heading.inline-richtext.h2',
            0
        )
        backgroundLoopFadeText(
            '#shopify-section-template--18887207288899__image_banner_GerqTG .banner__media',
            '#shopify-section-template--18887207288899__image_banner_GerqTG h2.banner__heading.inline-richtext.h2',
            1
        )

        if(document.querySelector('#shopify-section-template--18887207288899__image_banner_7XDTaA .banner__media')){
            document.querySelector('#shopify-section-template--18887207288899__image_banner_7XDTaA .banner__media img').style.opacity = '0'
        }
        if(document.querySelector('#shopify-section-template--18887207288899__image_banner_GerqTG .banner__media')){
            document.querySelector('#shopify-section-template--18887207288899__image_banner_GerqTG .banner__media img').style.opacity = '0'
        }

    });

    function backgroundLoopFade(seletor) {

        const elementos = document.querySelectorAll(seletor);
        if (!elementos.length) return;

        // ===== CONFIGURAÇÕES =====
        const tempoTroca = 5000; // tempo entre trocas (ms)
        const tempoFade  = 800;  // duração do fade (ms)

        const arrayImages = [
            'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/royal_red_orient_2eb14603-1491-427c-909b-ddd69d88a911.png?v=1778593849',
            'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/arabic_strong_arabic_silver_3f67ff44-e1ae-4b4e-a32e-736d209f88d7.png?v=1778593849',
            'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/oud_girl_41758cd3-f90a-4630-81b2-080beb90ad52.png?v=1778593849'
        
        ];
        // ========================

        let index = 0;

        elementos.forEach(el => {
            el.style.backgroundSize = 'contain';
            el.style.backgroundPosition = 'center';
            el.style.backgroundRepeat = 'no-repeat';
            el.style.transition = `opacity ${tempoFade}ms ease`;
            mobile<768 ? el.style.height = '50vh' : el.style.height = 'calc(50vh + 250px)'
        });

        function trocarImagem() {

            elementos.forEach(el => {

                el.style.opacity = '0';

                setTimeout(() => {

                    el.style.backgroundImage = `url("${arrayImages[index]}")`;
                    el.style.opacity = '1';

                }, tempoFade);

            });

            // avança índice usando módulo (loop infinito)
            index = (index + 1) % arrayImages.length;

        }

        // primeira imagem imediata
        trocarImagem();

        // loop infinito
        setInterval(trocarImagem, tempoTroca);

    }


    function backgroundLoopFadeText(seletorImg, seletorTexto, indexSection) {

    const elementos = document.querySelectorAll(seletorImg);
    const textos = document.querySelectorAll(seletorTexto);

    if (!elementos.length) return;

    // ===== CONFIGURAÇÕES =====
    const tempoTroca = 5000; // tempo entre trocas
    const tempoFade  = 800;  // duração do fade
    let arrayImages = []
    let arrayTextos = []

    if(indexSection == 0){
        arrayImages = [
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/blossom_blis_banner.png?v=1778612198',
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/arabian_elixir_land_a0e33a3e-ab20-4bd5-a5b7-dc092a6991ed.jpg?v=1778612198',
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/banner_nner.png?v=1778615425'
        ];

         arrayTextos = [
        `ㅤ<br>ㅤ`,
        `ㅤㅤ<br>ㅤㅤ`,
        `ㅤㅤㅤ<br>ㅤㅤㅤ`
    ];
    }
    if(indexSection == 1){
        arrayImages = [
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/tobacco_oud_purewa_banner_b896f81c-d654-4dbe-bffb-76fa301b71ef.png?v=1778681496',
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/blossom_bliss_c_2a140cef-fbd6-43a2-9859-3461d2be791d.jpg?v=1778608248'
        ];

         arrayTextos = [
        `<span class="content-left-benner-media">ㅤㅤㅤㅤㅤ <br> ㅤㅤㅤㅤ</span>`,
        `<span class="content-top-benner-media"ㅤㅤㅤㅤㅤ</span>`,
    ];
    }

   
    // ========================

    let index = 0;

    elementos.forEach(el => {
        mobile<768 ? el.style.backgroundSize = 'auto 100%' : el.style.backgroundSize = 'cover';
        mobile<768 ? el.style.backgroundPosition = '70% 100%' : el.style.backgroundPosition = 'center';       
        el.style.backgroundRepeat = 'no-repeat';
        el.style.transition = `opacity ${tempoFade}ms ease`;
    });

    textos.forEach(el => {
        el.style.transition = `opacity ${tempoFade}ms ease`;
        el.classList.add('carter-sans');
        el.classList.add('text-white');
        mobile< 768 ? el.classList.add('fs-4') : el.classList.add('fs-1');
        el.style.cssText = `text-shadow: 0px 0px 10px rgba(0,0,0,0.5);`;
    });

    function trocar() {

        elementos.forEach(el => el.style.opacity = '0');
        textos.forEach(el => el.style.opacity = '0' );

        setTimeout(() => {

            elementos.forEach(el => {
                el.style.backgroundImage = `url("${arrayImages[index]}")`;
                el.style.opacity = '1';
            });

            textos.forEach(el => {
                el.innerHTML = arrayTextos[index];
                el.style.opacity = '1';
            });

        }, tempoFade);

        index = (index + 1) % arrayImages.length;

    }

    trocar();
    setInterval(trocar, tempoTroca);

    }
    

    const allBannerImages = document.querySelectorAll('div#Banner-template--18887207288899__image_banner_7XDTaA, div#Banner-template--18887207288899__image_banner_GerqTG')
    allBannerImages.forEach((banner,i)=>{

        if(mobile<768){
            banner.classList.contains('banner--large') ? banner.classList.replace('banner--large','banner--medium') : null ;
            banner.querySelector('.banner__content').style.cssText = `
                flex-direction: column;
                justify-content: end;
            `
        }
    })

        const productCardInfoFull = document.querySelectorAll('.fullCollectionSwiper .product-card-custom')

        if(productCardInfoFull){
            productCardInfoFull.forEach((card)=>{
                if(card.classList.contains('d-grid')){card.classList.remove('d-grid')}
            })
        }

        const rfTitle = document.querySelector('.rf__title span')

        if(rfTitle){rfTitle.classList.add('carter-sans','fs-4','text-uppercase')}


        document.addEventListener('DOMContentLoaded',()=>{
                    setTimeout(()=>{
                        const wishlistheroContainer = document.querySelector('div#wishlisthero-floating-launcher-container')

                        if(wishlistheroContainer){
                                wishlistheroContainer.style.cssText = `
                                    opacity: 1;                            
                                `
                            wishlistheroContainer.querySelector('div').style.top = '50%';
                            wishlistheroContainer.querySelector('div').style.transform = 'translateY(-50%)'
                            wishlistheroContainer.querySelector('div').style.right = '20px';
                            wishlistheroContainer.querySelector('div').style.maxHeight = '42px';
                        }

                          function equalizeHeights(selector) {
                                    const elements = document.querySelectorAll(selector);                                    
                                    let maxHeight = 0;

                                    // Resetar altura antes de medir
                                    elements.forEach(el => {
                                        el.style.height = 'auto';
                                    });

                                    // Calcular maior altura real
                                    elements.forEach(el => {
                                        const height = el.offsetHeight;
                                        if (height > maxHeight) {
                                            maxHeight = height;
                                        }
                                    });
                                   
                                    const isMobile = window.innerWidth < 768;
                                   
                                    elements.forEach(el => {
                                        el.style.height = isMobile
                                            ? `${maxHeight}px`
                                            : `${maxHeight}px`;
                                    });
                                }

                                // init
                                equalizeHeights('.swiper-slide .product-card__title');

                                // importante: recalcular no resize
                                window.addEventListener('resize', () => {
                                    equalizeHeights('.swiper-slide .product-card__title');
                                });
                        
                    },500)
        
                })

    /*--------------------------------------------------------------------------------
    # ALL EQUALIZE HEIGHT HOME PAGE|||||||||||||||||||||||||||||||||||||||||||||||||||
    --------------------------------------------------------------------------------*/

    // document.addEventListener('DOMContentLoaded',()=>{
    //             function equalizeHeights(selector) {
    //                                 const elements = document.querySelectorAll(selector);                                    
    //                                 let maxHeight = 0;

    //                                 // Resetar altura antes de medir
    //                                 elements.forEach(el => {
    //                                     el.style.height = 'auto';
    //                                 });

    //                                 // Calcular maior altura real
    //                                 elements.forEach(el => {
    //                                     const height = el.offsetHeight;
    //                                     if (height > maxHeight) {
    //                                         maxHeight = height;
    //                                     }
    //                                 });

    //                                 // Detectar viewport
    //                                 const isMobile = window.innerWidth < 768;

    //                                 // Aplicar altura
    //                                 elements.forEach(el => {
    //                                     el.style.height = isMobile
    //                                         ? `${maxHeight * 0.5}px`
    //                                         : `${maxHeight}px`;
    //                                 });
    //                 }

    //                 equalizeHeights('.slide client')
    // })

}

if( document.body.classList.contains('product-produtos-purewa-custom') ||
    document.body.classList.contains('product-layers-kits-custom')){

    const quantity = document.querySelector('.quantity_square')

    if(quantity){
        quantity.classList.replace('quantity_square','quantity')
    }

    const buyButton = document.querySelector('.buy-button-card')
    const buttonCart = document.querySelector('.product-form__submit')

    buyButton.addEventListener('click',()=>{
        buttonCart.click()
    })

    const controle = 0; // começa a aplicar a partir do índice 3

        const containers = document.querySelectorAll('.container');

        function updatePadding() {
            containers.forEach((container, indice) => {
                if (indice > controle && window.innerWidth < 768) {
                    container.classList.add('p-0');
                } else {
                    container.classList.remove('p-0');
                }
            });
        }

        updatePadding();
        window.addEventListener('resize', updatePadding);
    
}

if(
    document.body.classList.contains('product-custom') ||
    document.body.classList.contains('product-produtos-purewa-custom')){

        console.log('product-produtos-purewa-custom')

    const section = $$('section')

    if(section){
        section.forEach(s => {
            if(!s.classList.contains('not')){
                s.style.margin = "0";
            }
        });
    }

    const containerReviewApp = document.querySelector('section#shopify-section-template--18887207452739__177437767235bdd677 .scroll-trigger')

    document.addEventListener('DOMContentLoaded', ()=>{
        if(containerReviewApp){
            console.log(containerReviewApp)
            containerReviewApp ? containerReviewApp.classList.replace('page-width','container') : null
        }
    })


    const cartesSans = $$('.carter-sans, .rich-title__caption')

    if(cartesSans){
        cartesSans.forEach((carter)=>{
               if(carter.classList.contains('text-start') && mobile<768){
                    carter.classList.replace('text-start','text-center')
               }
        })
    }

}

if(document.body.classList.contains('collection-custom')){

    const section = $$('section')

    if(section){
        section.forEach(s => {
            if(!s.classList.contains('not')){
                s.style.margin = "0";
            }
        });
    }

    const bannerLarge = $('div#Banner-template--18887207223363__image_banner_YBxHG3')

    if(bannerLarge){
        if(mobile>992 && mobile<1800){
            bannerLarge.classList.replace('banner--large','banner--medium')
        }

        bannerLarge.querySelector('h2.banner__heading.inline-richtext.h2').innerHTML = `
        Crie seu cheiro. Crie sua vibe.<br>
        Camadas que revelam quem você é.
        `

        bannerLarge.querySelector('h2.banner__heading.inline-richtext.h2').style.cssText = `
        opacity: 1;
        `
    }

}

if(
    document.body.classList.contains('page-perfumes-custom') ||
    document.body.classList.contains('page-edicoes-especiais-custom') ||
    document.body.classList.contains('page-mais-desejados-custom') ||
    document.body.classList.contains('page-body-mists-custom') ||
    document.body.classList.contains('page-kits-e-experiencias-custom') ||
    document.body.classList.contains('page-sobre-nos-custom') ||
    document.body.classList.contains('page-politica-de-privacidade-custom') ||
    document.body.classList.contains('page-termos-de-uso-custom') ||
    document.body.classList.contains('page-programa-de-recompensas-custom') ||
    document.body.classList.contains('page-perguntas-frequentes-custom') || 
    document.body.classList.contains('page-perguntas-frequentes-custom') || 
    document.body.classList.contains('page-devolucoes-e-envios-custom')  
  ){

    const section = $$('section')

    if(section){
        section.forEach(s => {
            if(!s.classList.contains('not')){
                s.style.marginTop = "0";
            }
        });
    }
}

if(document.body.classList.contains('page-body-mists-custom')){

    const bannerSubTitle = $('.banner-subtitle')
    const bannerTitle = $('.banner-title')
    
    mobile>992 ? bannerSubTitle.innerHTML = `Estilo que<br> deixa marca.` : null
    
}

if(document.body.classList.contains('page-edicoes-especiais-custom')){

    const bannerSubTitle = $('.banner-subtitle')
    const bannerTitle = $('.banner-title')

    mobile>992 ?  bannerTitle.innerHTML = `Criadas para quem não<br> aceita o comum` : null
}

if(document.body.classList.contains('page-mais-desejados-custom')){

    const bannerSubTitle = $('.banner-subtitle')
    const bannerTitle = $('.banner-title')

    mobile>992 ?  bannerSubTitle.innerHTML = `Presença que não<br> passa despercebida` : null
}

if(document.body.classList.contains('page-kits-e-experiencias-custom')){

    const bannerSubTitle = $('.banner-subtitle')
    const bannerTitle = $('.banner-title')

    mobile>992 ?  bannerSubTitle.innerHTML = `Personalidade<br> que marca` : null
}

if(
    document.body.classList.contains('page-sobre-nos-custom') ||
    document.body.classList.contains('page-politica-de-privacidade-custom') ||
    document.body.classList.contains('page-termos-de-uso-custom') ||
    document.body.classList.contains('page-programa-de-recompensas-custom') 
    ){
    $('section#shopify-section-sections--18887207747651__custom_liquid_yVmWNH') ?
    $('section#shopify-section-sections--18887207747651__custom_liquid_yVmWNH').style.display = 'none' :
    null
}

if (document.body.classList.contains('article-post-blog-purewa-custom')) {

    const articleCard = document.querySelectorAll('.article-editorial-template__card');

    articleCard.forEach((card, index) => {
        card.style.order = `${articleCard.length - index}`
    });

}


/*--------------------------------------------------------------------------------
# FOOTER JS CUSTOM ALL STORE |||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

function highlightText(selector, words) {
  const elements = document.querySelectorAll(selector);

  // escapa palavras
  const escapedWords = words.map(word =>
    word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );

  // regex única
  const regex = new RegExp(`(${escapedWords.join('|')})`, 'gi');

  elements.forEach(el => {
    const text = el.textContent;

    // controle de palavras já usadas
    const used = new Set();

    const newHTML = text.replace(regex, (match) => {
      const key = match.toLowerCase();

      if (!used.has(key)) {
        used.add(key);
        return `<strong>${match}</strong>`;
      }

      return match; // mantém as próximas ocorrências sem alterar
    });

    el.innerHTML = newHTML;
  });
}

highlightText('.sn-highlight-paragraph', [
  'sobre',
  'sentir',
  'viver',
  'marcar',
  'presença',
  'você',
  'lembrado',
]);

const oldFooterBlockNewsLetter = $('.old__footer-block__newsletter')

oldFooterBlockNewsLetter ? oldFooterBlockNewsLetter.remove() : null

const footerBlock = $$('footer .footer-block')
const footerBlockNews = $('.footer-block__newsletter')
const footerCopyright = $('.footer__copyright.caption')

if(footerBlock){
    footerBlock.forEach((block) =>{

        if(block.querySelector('h2.footer-block__heading').textContent.trim() === 'Purewa'){

            block.querySelector('h2.footer-block__heading').style.display = 'none';

            const ul = block.querySelector('ul')

            ul.addEventListener('click',()=>{
                window.location.href = "https://purewa.com.br/"
            })

            ul.style.cssText = `
                cursor: pointer;
                ${ mobile<992 ? 'display: grid; justify-content: center;' : null }
            `

            ul.innerHTML = `
            <li>
                <picture>
                    <source 
                    srcset="//cdn.shopify.com/s/files/1/0673/0770/0291/files/Logo_Purewa_alta.webp?v=1773694088" 
                    type="image/webp">
                    <img 
                        src="//cdn.shopify.com/s/files/1/0673/0770/0291/files/Logo_Purewa_alta_footer.png?v=1773694057"
                        alt="Purewa"
                        class="img-fluid"
                        loading="lazy"
                        width="180"
                        height=""
                        style="object-fit: contain;
                                max-width: 157px;"
                    >
                </picture>
            </li>
            <li>Presença que fica.</li>
            `
        }

        if(footerBlockNews && footerBlockNews.querySelector('label.field__label')){
            if(footerBlockNews.querySelector('label.field__label').textContent.trim() === 'E-mail'){
                footerBlockNews.querySelector('label.field__label').textContent = 'ENDEREÇO DE EMAIL';
            }

            $('.newsletter-form__button.field__button').innerHTML = `INSCREVER-SE`
        }
    })
}

if(footerCopyright){

    footerCopyright.style.textAlign = 'left';

    footerCopyright.innerHTML = `
         PUREWA COSMÉTICOS<br><br>
        Alameda Yayá, 814 - Sala 01A - Jd. Aida - Guarulhos - SP<br>
        SÃO PAULO - CEP: 07060-000 / CNPJ: 43.640.155/0001-03
    `
}